import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { HeatmapLayer } from '@ngui/map';

@Component({
	selector: 'app-heat-map',
	templateUrl: './heat-map.component.html',
	styleUrls: ['./heat-map.component.scss'],
})
export class HeatMapComponent implements OnInit {
	@ViewChild(HeatmapLayer) heatmapLayer: HeatmapLayer;
	public heatmap: google.maps.visualization.HeatmapLayer;
	public map: google.maps.Map;
	public points = [];
	public center: string;

	@Input() complaints: any;

	constructor() {}

	ngOnInit(): void {
		this.getComplaints();
	}

	getComplaints(): void {
		setTimeout(() => {
			this.complaints.forEach((complaint) => {
				this.points.push(
					new google.maps.LatLng(complaint.latitude, complaint.longitude)
				);
				this.center = complaint.latitude + ', ' + complaint.longitude;
			});
			this.heatmapLayer['initialized$'].subscribe((heatmap) => {
				this.heatmap = heatmap;
				this.map = this.heatmap.getMap();
			});
		}, 2000);
	}

	toggleHeatmap(): void {
		this.heatmap.setMap(this.heatmap.getMap() ? null : this.map);
	}

	changeGradient(): void {
		const gradient = [
			'rgba(0, 255, 255, 0)',
			'rgba(0, 255, 255, 1)',
			'rgba(0, 191, 255, 1)',
			'rgba(0, 127, 255, 1)',
			'rgba(0, 63, 255, 1)',
			'rgba(0, 0, 255, 1)',
			'rgba(0, 0, 223, 1)',
			'rgba(0, 0, 191, 1)',
			'rgba(0, 0, 159, 1)',
			'rgba(0, 0, 127, 1)',
			'rgba(63, 0, 91, 1)',
			'rgba(127, 0, 63, 1)',
			'rgba(191, 0, 31, 1)',
			'rgba(255, 0, 0, 1)',
		];
		this.heatmap.set(
			'gradient',
			this.heatmap.get('gradient') ? null : gradient
		);
	}

	changeRadius(): void {
		this.heatmap.set('radius', this.heatmap.get('radius') ? null : 20);
	}

	changeOpacity(): void {
		this.heatmap.set('opacity', this.heatmap.get('opacity') ? null : 0.2);
	}
}
